import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";

import { country, currentUser } from "./../../Config/Data";

import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import BackButton from "../../Components/BackButton";
import CustomInput from "../../Components/CustomInput";
import CustomButton from "../../Components/CustomButton";
import { SelectBox } from "../../Components/CustomSelect";
import CustomModal from "../../Components/CustomModal";

import './style.css'
import { useSelector } from "react-redux";
import { useUpdateUserMutation } from "../../Redux/Apis/User";
import { useUpdateAdminMutation } from "../../Redux/Apis/Admin";
import { useGetNeighborhoodsQuery } from "../../Redux/Apis/Neighborhood";
import { useUploadImageMutation } from "../../Redux/Apis/General";
import { placeholderImage } from "../../Assets/images";
import { Form } from "react-bootstrap";

const EditProfile = () => {

  const { user } = useSelector(state => state.authSlice)
  const [updateUser, { isLoading, isSuccess }] = useUpdateUserMutation()
  const [updateAdmin, { isLoading: adminLoading, isSuccess: adminSuccess }] = useUpdateAdminMutation()
  const { data: neighborhoodsData } = useGetNeighborhoodsQuery()
  const [uploadImage, { isLoading: imageLoading }] = useUploadImageMutation()

  const isAdmin = user?.role === 'super_admin' || user?.role === 'neighborhood_admin'

  const navigate = useNavigate()

  const [userData, setUserData] = useState();
  const [showModal, setShowModal] = useState(false);

  const handleClickPopup = async () => {

    let data = { ...userData }

    if (userData?.updatedImage) {

      let formData = new FormData()

      formData.append('image', userData.updatedImage)
      let response = await uploadImage(formData)

      data.profile_photo = response.data.data.path
      delete data.updatedImage

      if (isAdmin) {
        await updateAdmin({ id: user._id, payload: data })
      } else {
        await updateUser({ payload: data })
      }

    } else {

      delete data.picture

      if (isAdmin) {
        await updateAdmin({ id: user._id, payload: data })
      } else {
        await updateUser({ payload: data })
      }

    }

  }

  useEffect(() => {
    document.title = 'Landing List | Edit Profile';
    setUserData({
      first_name: user?.first_name,
      last_name: user?.last_name,
      name: user?.name,
      defaultNeighborhood: user?.defaultNeighborhood?._id || ''
    });
  }, []);

  useEffect(() => {
    if (isSuccess || adminSuccess) {
      setShowModal(true);
      // if (userData.updatedImage) {
      //     let data = { ...userData }
      //     delete data.updatedImage
      //     setUserData(data)
      // }
    }
  }, [isSuccess, adminSuccess])

  return (
    <>
      <DashboardLayout>
        <div className="dashCard mb-4">
          <div className="row mb-3">
            <div className="col-12">
              <h2 className="mainTitle">
                <BackButton />
                Edit Profile
              </h2>
            </div>
          </div>
          <div className="row mb-3">
            {
              userData ?
                <div className="col-12">
                  <form>
                    <div className="row mb-3">
                      <div className="col-lg-4 order-2 order-lg-1 mb-3">
                        <div className="profileImage">
                          <img src={userData?.updatedImage ?
                            URL.createObjectURL(userData?.updatedImage) :
                            user?.profile_photo ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${user?.profile_photo}` :
                              placeholderImage
                          } alt="User" />
                          <input type="file" accept="img/*" className="d-none" id="profileImage" onChange={(event) => { setUserData({ ...userData, updatedImage: event.target.files[0] }) }} />
                          {/* <input type="file" accept="img/*" className="d-none" id="profileImage" onChange={(event) => console.log("Imaaaaaage", event.target.files)} /> */}
                          <label htmlFor="profileImage" className="imageUploadButton"><FontAwesomeIcon icon={faCamera} /></label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <CustomInput label="First Name" labelClass="mainLabel" required type="text" placeholder="Enter First Name" inputClass="mainInput" value={userData?.first_name} onChange={(event) => { setUserData({ ...userData, first_name: event.target.value }) }} />
                          </div>
                          <div className="col-md-6 mb-3">
                            <CustomInput label="Last Name" labelClass="mainLabel" required type="text" placeholder="Enter Last Name" inputClass="mainInput" value={userData?.last_name} onChange={(event) => { setUserData({ ...userData, last_name: event.target.value }) }} />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 mb-3">
                            <h4 className="secondaryLabel">Email Address</h4>
                            <p className="secondaryText">{user?.email}</p>
                          </div>
                        </div>

                        {/* Admin-specific: Default Neighborhood */}
                        {isAdmin && (user?.role === 'super_admin' || user?.assignedNeighborhoods?.length > 1) && (
                          <div className="row">
                            <div className="col-12 mb-3">
                              <label className="mainLabel">Default Neighborhood (Optional)</label>
                              <Form.Select
                                className="mainInput"
                                value={userData?.defaultNeighborhood || ''}
                                onChange={(e) => setUserData({ ...userData, defaultNeighborhood: e.target.value })}
                              >
                                <option value="">Select default neighborhood...</option>
                                {user?.role === 'super_admin' ? (
                                  // Super admin sees all neighborhoods
                                  (neighborhoodsData?.data || []).map(n => (
                                    <option key={n._id} value={n._id}>{n.name}</option>
                                  ))
                                ) : (
                                  // Neighborhood admin sees only assigned
                                  (user?.assignedNeighborhoods || []).map(n => (
                                    <option key={n._id} value={n._id}>{n.name}</option>
                                  ))
                                )}
                              </Form.Select>
                              <small className="text-muted">
                                You'll start here when logging in to the admin panel
                              </small>
                            </div>
                          </div>
                        )}
                        {/* <div className="row">
                                                    <div className="col-12 mb-3">
                                                        <CustomInput label="Phone Number" labelClass="mainLabel" required type="text" placeholder="Phone Number" inputClass="mainInput" value={userData?.phoneNumber} onChange={(event) => { setUserData({ ...userData, phoneNumber: event.target.value }) }} />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <SelectBox selectClass="mainInput" name="Select Country" label="Country" required option={optionData}
                                                            onChange={(event) => { setUserNewData({ ...userNewData, country: event.target.value }) }}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <SelectBox selectClass="mainInput" name="Select State" label="State" required option={optionData} />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <SelectBox selectClass="mainInput" name="Select City" label="City" required option={optionData} />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <CustomInput label="Postal/Zip Code" labelClass="mainLabel" required type="number" placeholder="Enter Postal/Zip Code" inputClass="mainInput" onChange={(event) => { setUserNewData({ ...userNewData, name: event.target.value }) }} />
                                                    </div>
                                                </div> */}
                      </div>
                      <div className="col-12">
                        <CustomButton type="button" variant="primaryButton" className="me-3 mb-2" text="Save" onClick={handleClickPopup} loading={isLoading || imageLoading || adminLoading} />
                        <CustomButton type="button" variant="secondaryButton" className="me-3 mb-2" text="Cancel" onClick={() => { navigate('/profile') }} />
                      </div>

                    </div>
                  </form>
                </div> : ''
            }
          </div>
        </div>
        <CustomModal show={showModal} close={() => { setShowModal(false) }} success heading='Your profile is Successfully Updated! Continue' />
      </DashboardLayout>
    </>
  );
};

export default EditProfile;
